/* tslint:disable */
/* eslint-disable */
/**
 * API SPECS
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VaccinationSchedulesRequest
 */
export interface VaccinationSchedulesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof VaccinationSchedulesRequest
     */
    vaccineIdList?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof VaccinationSchedulesRequest
     */
    dateMeeting?: string;
    /**
     * 
     * @type {number}
     * @memberof VaccinationSchedulesRequest
     */
    babyId?: number;
}

/**
 * Check if a given object implements the VaccinationSchedulesRequest interface.
 */
export function instanceOfVaccinationSchedulesRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VaccinationSchedulesRequestFromJSON(json: any): VaccinationSchedulesRequest {
    return VaccinationSchedulesRequestFromJSONTyped(json, false);
}

export function VaccinationSchedulesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VaccinationSchedulesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'vaccineIdList': !exists(json, 'vaccineIdList') ? undefined : json['vaccineIdList'],
        'dateMeeting': !exists(json, 'dateMeeting') ? undefined : json['dateMeeting'],
        'babyId': !exists(json, 'babyId') ? undefined : json['babyId'],
    };
}

export function VaccinationSchedulesRequestToJSON(value?: VaccinationSchedulesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'vaccineIdList': value.vaccineIdList,
        'dateMeeting': value.dateMeeting,
        'babyId': value.babyId,
    };
}

